import { useState } from "react"

import LinkButton from "#blocks/LinkButton"
import TextOverrun from "#blocks/TextOverrun"
import { Uuid } from "#customTypes/globalTypes"
import AddStudentFormModal from "#forms/AddStudent/AddStudentFormModal"

const ClickableStudentName = ({
  studentId,
  label,
}: {
  studentId: Uuid
  label: string
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <LinkButton onClick={() => setIsOpen(true)} style={{ minWidth: 0 }}>
        <TextOverrun text={label} />
      </LinkButton>
      {isOpen && (
        <AddStudentFormModal
          onClose={() => setIsOpen(false)}
          studentId={studentId}
        />
      )}
    </>
  )
}

export default ClickableStudentName
